<script>
    import Route, {router} from "../lib/Router/Router.svelte";
    import app from "../stores/app";
    import user from "../stores/user";
    import R, {LOADER} from "../lib/requests";
    import {formatDate, getDate, humanDate} from "../lib/lib";
    import Breadcrumb from "../components/Breadcrumb.svelte";
    import PageHeader from "../components/PageHeader.svelte";
    import CalendarNavigation from "./CalendarNavigation.svelte";
    import AppIcon from "../components/icons/AppIcon.svelte";
    import Alert from "../stores/alerts";
    import Notifier from "../stores/notifier";
    import ReservationEditModal from "../reservations/ReservationEditModal.svelte";
    import {RESERVATION_STATUS, USER_ROLE} from "../lib/constants";

    export let date = null;
    export let callbackFunction = null;

    const breadcrumb = [
        {id: 'calendar', name: 'Calendar', link: `/app/calendar`}
    ];
    const pageHeaderControls = [
        {id: 'today', name: 'TODAY', class: 'hidden-xs'},
        {id: 'create', name: 'NEW RESERVATION', class: 'hidden-xs'},
        {
            id: 'create',
            name: '',
            icon: 'plus-circle',
            class: 'hidden-xl hidden-lg hidden-md hidden-sm'
        },
    ];


    let reservations = null;
    let toursDate = null;
    let totalPersons = 0;
    let selectedId = 0;
    let editId = null;
    let stopSale = false;

    const load = (loader = LOADER.PAGE) => {
        const onSuccess = result => {
            reservations = [];
            totalPersons = 0;
            result.reservations.map(item => {
                if (item.status == RESERVATION_STATUS.ACTIVE) {
                    totalPersons += ~~item.persons;
                }

                if ($user.role == USER_ROLE.AGENT && item.agent_id != $user.agent_id) {
                    return;
                }

                reservations.push(item);
            });
            stopSale = result.stop_sale;
        }

        const onFailure = err => {
            let message = err.message ? err.message : "There was an error occurred while loading date data.";
            Alert.warning("Transfers", message);
        };

        toursDate = date;
        let data = {
            date_at: date,
            sort_field: 'status, created_at',
            // sort_way: 'ASC',
        }
        R.handle(R.reservation.dayIndex, data, onSuccess, onFailure, loader);
    }

    const onPreviousDay = () => {
        let dt = new Date(date);
        date = formatDate(new Date(dt.getTime() - 24 * 60 * 60 * 1000), 'y-m-d')
        router.go(`/app/calendar/${date}`)();
    }

    const onNextDay = () => {
        let dt = new Date(date);
        date = formatDate(new Date(dt.getTime() + 24 * 60 * 60 * 1000), 'y-m-d');
        router.go(`/app/calendar/${date}`)();
    }

    const onToday = () => {
        date = getDate();
        router.go(`/app/calendar/${date}`)();
    }

    const onCreate = () => {
        let today = formatDate(new Date(), 'y-m-d');
        if (user.isAgent() && toursDate < today) {
             Notifier.showError("You cannot add a reservation to a past date.");
            return;
        }

        if (totalPersons >= $app.settings.max_cruise_persons) {
            Notifier.showError("The number of persons exceeds the daily limit!");
            return;
        }

        if (stopSale) {
            Notifier.showError("Sales have stopped on this day!");
            return;
        }

        editId = 0;
    }

    const onEdit = (group) => {
        selectedId = group.id;
        editId = group.id;
    }

    const closeEdit = data => {
        if (data) {
            load(LOADER.POPUP);
            if (callbackFunction) {
                callbackFunction();
            }
        }
        editId = null;
    }

    const onDelete = group => {
        Alert.delete("Delete reservation", `This will permanently delete the reservation for ${group.persons} persons.\nAre you sure?`,
            () => deleteReservation(group.id)
        );
    }

    const deleteReservation = (id) => {
        const onSuccess = result => {
            reservations = reservations.filter(x => x.id !== result);
            Notifier.showMessage("Reservation deleted");

            if (callbackFunction) {
                callbackFunction();
            }
        }

        const onFailure = err => {
        };

        R.handle(R.reservation.delete, id, onSuccess, onFailure, LOADER.POPUP);
    }

    load();

    $: {
        if (toursDate !== date) {
            load();
        }
    }
</script>

<Breadcrumb {breadcrumb}/>
<PageHeader title="Daily Reservations" controls={ pageHeaderControls } on:today={ onToday } on:create={onCreate}/>
<CalendarNavigation title="{ humanDate(date) }"
                    on:click_previous="{ onPreviousDay }"
                    on:click_next="{ onNextDay }"/>
{#if reservations != null}
    {#if stopSale}
        <div class="text-danger fw-bold fs-6 text-center mb-4">
            <AppIcon icon="stop-hand" size="24"/>
            Sales have stopped on this day
            {#if stopSale.reason}
                <div class="fw-normal">{stopSale.reason}</div>
            {/if}
        </div>
    {:else}
        <div class="text-center mb-4">
            {#if $app.settings.max_cruise_persons - totalPersons > 0}
                Day availability: <b>{$app.settings.max_cruise_persons - totalPersons}</b> persons
            {:else}
                <span class="text-danger fw-bold">There is no availability for this day!</span>
            {/if}
        </div>
    {/if}

    {#if reservations.length > 0}
        <div class="text-center mb-4">
            <b>{totalPersons}/{$app.settings.max_cruise_persons}</b> persons
        </div>

        <div class="mb-4">
            {#each reservations as item}
                <div class="panel panel-default mb-4">
                    <div class="panel-heading pe-1">
                        <button class="btn-reset is-link py-1" on:click={() => onEdit(item)}>
                            <b>{item.persons}</b> persons
                            {#if item.status == RESERVATION_STATUS.CANCELED}
                                -
                                <span class="text-danger fw-bold">Canceled</span>
                            {/if}
                        </button>
                        <div>
                            {#if user.isAdmin()}
                                {#if item.agent?.phone}
                                    <a href="tel:{item.agent.phone}"
                                       class="btn tn-default blue-icon hidden-sm hidden-xs"
                                       title="call agent">
                                        <AppIcon icon="phone"/>
                                    </a>
                                {/if}
                                <!--{#if item.agent?.mobile}-->
                                <!--    <a href="tel:{item.agent.mobile}"-->
                                <!--       class="btn tn-default blue-icon hidden-sm hidden-xs"-->
                                <!--       title="call agent">-->
                                <!--        <AppIcon icon="mobile"/>-->
                                <!--    </a>-->
                                <!--{/if}-->
                                {#if item.agent?.users?.length > 0}
                                    {#each item.agent.users as user}
                                        {#if user.mobile}
                                            <a href="tel:{user.mobile}"
                                               class="btn tn-default blue-icon px-2"
                                               title="call user">
                                                <AppIcon icon="mobile"/>
                                            </a>
                                        {/if}
                                    {/each}
                                {/if}
                                {#if item.agent?.email}
                                    <a href="mailto:{item.agent.email}"
                                       class="btn tn-default blue-icon hidden-sm hidden-xs"
                                       title="email to agent">
                                        <AppIcon icon="envelope"/>
                                    </a>
                                {/if}
                            {/if}
                            <button class="btn btn-default py-1" title="delete"
                                    on:click={ () => onDelete(item) }>
                                <AppIcon icon="trash" size="16"/>
                            </button>
                        </div>
                    </div>
                    <div class="panel-body panel-pad" class:canceled={item.status == RESERVATION_STATUS.CANCELED}>
                        <div class="reservation-content">
                            <div class="row">
                                <div class="col-md-6">
                                    <div class="smaller">Name</div>
                                    <div class:fst-italic={!item.name}>
                                        {#if item.name}
                                            {item.name}
                                        {:else}
                                            name not provided
                                        {/if}
                                    </div>
                                    {#if item.phone}
                                        <div class="smaller mt-2">Phone</div>
                                        <a href="teL:{item.phone}">{item.phone}</a>
                                    {/if}
                                </div>
                                {#if user.isAdmin()}
                                    <div class="col-md-6">
                                        {#if item.agent}
                                            <div class="reservation-owners">

                                                <div class="text-gray owner">
                                                    <div class="smaller">
                                                        Agent
                                                    </div>
                                                    {item.agent.name}
                                                </div>

                                                {#if user.isAdmin()}
                                                    <div class="text-end hidden-xl hidden-lg hidden-md">
                                                        <div class="smaller">Contact agent</div>
                                                        <div>
                                                            {#if item.agent?.phone}
                                                                <a href="tel:{item.agent.phone}"
                                                                   class="btn tn-default blue-icon px-2"
                                                                   title="call agent">
                                                                    <AppIcon icon="phone"/>
                                                                </a>
                                                            {/if}
                                                            {#if item?.agent.users.length > 0}
                                                                {#each item.agent.users as user}
                                                                    {#if user.mobile}
                                                                        <a href="tel:{user.mobile}"
                                                                           class="btn tn-default blue-icon px-2"
                                                                           title="call agent">
                                                                            <AppIcon icon="mobile"/>
                                                                        </a>
                                                                    {/if}
                                                                {/each}
                                                            {/if}
                                                            {#if item.agent?.email}
                                                                <a href="mailto:{item.agent.email}"
                                                                   class="btn tn-default blue-icon px-2"
                                                                   title="email to agent">
                                                                    <AppIcon icon="envelope"/>
                                                                </a>
                                                            {/if}
                                                        </div>
                                                    </div>
                                                {/if}

                                                <!--{#if item.user}-->
                                                <!--    <div class="text-gray owner">-->
                                                <!--        <div class="smaller">-->
                                                <!--            User-->
                                                <!--        </div>-->
                                                <!--        {item.user.name}-->
                                                <!--    </div>-->
                                                <!--{/if}-->
                                            </div>
                                        {/if}
                                    </div>
                                {/if}
                            </div>
                            {#if item.notes}
                                <div class="reservation-notes">
                                    {@html item.notes.replace("\n", "<br>")}
                                </div>
                            {/if}
                        </div>
                    </div>
                </div>
            {/each}
        </div>

    {:else}
        <div class="panel-simple text-center p-3">
            {#if user.isAgent()}
                You have no reservations for this day
            {:else}
                No reservations found for this day.
            {/if}
        </div>
    {/if}
{/if}

{#if editId != null}
    <ReservationEditModal reservationId={editId} reservationDate={toursDate}
                          closeCallback={closeEdit}/>
{/if}

<style>

    .canceled {
        background: rgba(255, 0, 0, 0.1);
    }

    .reservation-notes {
        font-style: italic;
        color: #777777;
        border-top: 1px dotted var(--default-border-color);
        padding: 10px 0 0 0;
        margin-top: 10px;
    }

    .reservation-owners {
        display: flex;
        flex-direction: column;
        gap: 10px;
        width: max-content;
        margin: 0 0 0 auto;
    }

    .reservation-owners .owner {
        text-align: right;
    }

    @media (max-width: 576px) {
        .reservation-owners {
            flex-direction: row;
            justify-content: space-between;
            width: 100%;
            border-top: 1px dotted var(--default-border-color);
            padding-top: 10px;
            margin: 10px 0 0 0;
        }

        .reservation-owners .owner {
            text-align: left;
        }
    }
</style>